import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatRp } from "@/lib/tiers";
import { Users, Crown, Flame, FileText, Clock, DollarSign } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { (async () => { try { const { data } = await api.get("/admin/stats"); setStats(data); } catch (e) { console.error("Failed to load admin stats:", e); } })(); }, []);

  if (!stats) return <div className="text-zinc-500 font-mystic">Loading…</div>;

  const cards = [
    { icon: <Users className="w-5 h-5" />, label: "Total Users", value: stats.total_users, color: "text-zinc-300" },
    { icon: <Crown className="w-5 h-5" />, label: "Elite Cultists", value: stats.active_elite, color: "text-violet-400" },
    { icon: <Flame className="w-5 h-5" />, label: "Hardcore Cultists", value: stats.active_hardcore, color: "text-rose-400" },
    { icon: <FileText className="w-5 h-5" />, label: "Total Posts", value: stats.total_posts, color: "text-zinc-300" },
    { icon: <Clock className="w-5 h-5" />, label: "Pending Payments", value: stats.pending_payments, color: "text-amber-400" },
    { icon: <DollarSign className="w-5 h-5" />, label: "Monthly Revenue", value: formatRp(stats.monthly_revenue), color: "text-emerald-400" },
  ];

  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {cards.map((c) => (
        <div key={c.label} className="glass-strong rounded-xl p-5" data-testid={`stat-${c.label.toLowerCase().replace(/\s/g,'-')}`}>
          <div className={`flex items-center gap-2 ${c.color}`}>{c.icon}<span className="text-xs uppercase tracking-widest">{c.label}</span></div>
          <div className="font-display text-3xl font-bold text-white mt-2">{c.value}</div>
        </div>
      ))}
    </div>
  );
}
